import { useEffect } from "react";
import { useOptionalUser } from "@adsk/alloy-provider/es/UserContext";
import { useCurrentAccountId } from "@adsk/alloy-provider";
import { RequestStatus } from "../hooks/useRequests";
import { useAccounts } from "../hooks/useAccounts";
import { useProjects } from "../hooks/useProjects";
import { useAnalytics } from "../hooks/useAnalytics";
import {
  createOnSubmit,
  hasAccountAdminCreationPermissions,
  hasProjectAdminCreationPermissions,
} from "../shared/sharedCreateProjectTemplateHelpers";
export var useCreateTemplateModalProps = function (props) {
  // Configure API Request - Accounts
  var currentAccountId = useCurrentAccountId();
  var _a = useAccounts(),
    accounts = _a.data,
    accountsRequestStatus = _a.status,
    accountsRequestError = _a.error,
    fetchAccounts = _a.sendRequest;
  // Configure API Request - Projects
  var _b = useProjects(),
    projects = _b.data,
    projectsRequestStatus = _b.status,
    projectsRequestError = _b.error,
    fetchProjects = _b.sendRequest;
  // Configure API Request - Current User
  var user = useOptionalUser().data;
  // Configure Analytics
  var track = useAnalytics();
  //
  // Side Effects
  //
  // Side effect - fetch accounts and projects only when the state has changed to open
  useEffect(
    function () {
      if (props.open) {
        fetchAccounts();
        fetchProjects();
      }
    },
    [props.open, fetchAccounts, fetchProjects]
  );
  var filterAccountsWithoutCreation = function (accounts) {
    return accounts.filter(function (account) {
      return (
        hasAccountAdminCreationPermissions(account) ||
        hasProjectAdminCreationPermissions(account)
      );
    });
  };
  return {
    open: props.open,
    onClose: props.onClose,
    // Project data to populate the dropdown / loading state
    projects: {
      data: projects ? projects.data : [],
      loading: projectsRequestStatus === RequestStatus.PENDING,
      error: !!projectsRequestError,
    },
    // Account data to populate the dropdown / loading state
    accounts: {
      data:
        // If the accounts response has been returned, return accounts.data, otherwise return
        // an empty array (instead of the default null). accounts.data is also filtered to
        // exclude accounts that the user isn't allowed to create projects in.
        (accounts ? filterAccountsWithoutCreation(accounts.data) : [])
          // If currentAccountId is defined, filter the array to only include that account
          // If currentAccountId is undefined, do not filter any items
          .filter(function (account) {
            return currentAccountId ? currentAccountId === account.id : true;
          }),
      loading: accountsRequestStatus === RequestStatus.PENDING,
      error: !!accountsRequestError,
    },
    // Submit data
    // Async callback to pass the form data out of the UI
    // Spinner on submit button will appear while awaiting `onSubmit`
    onSubmit: createOnSubmit(user, props),
    track: track,
  };
};
